/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaveLeaderboardBody
 */
export interface LeaveLeaderboardBody {
    /**
     * Which occurrence to cancel, as a 1-indexed period number. Omit it when only one upcoming entry is held. Required when several are held, because choosing for the player would cancel a date they did not pick.
     * @type {number}
     * @memberof LeaveLeaderboardBody
     */
    periodNumber?: number;
}

/**
 * Check if a given object implements the LeaveLeaderboardBody interface.
 */
export function instanceOfLeaveLeaderboardBody(value: object): value is LeaveLeaderboardBody {
    return true;
}

export function LeaveLeaderboardBodyFromJSON(json: any): LeaveLeaderboardBody {
    return LeaveLeaderboardBodyFromJSONTyped(json, false);
}

export function LeaveLeaderboardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveLeaderboardBody {
    if (json == null) {
        return json;
    }
    return {
        
        'periodNumber': json['periodNumber'] == null ? undefined : json['periodNumber'],
    };
}

export function LeaveLeaderboardBodyToJSON(json: any): LeaveLeaderboardBody {
    return LeaveLeaderboardBodyToJSONTyped(json, false);
}

export function LeaveLeaderboardBodyToJSONTyped(value?: LeaveLeaderboardBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodNumber': value['periodNumber'],
    };
}

